var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
function CustomPanelLogo(_a) {
    var logo = _a.logo;
    return (React.createElement(PanelLogo, { src: logo, alt: "" }));
}
export { CustomPanelLogo };
var PanelLogo = styled.img.withConfig({ displayName: "PanelLogo", componentId: "sc-v7cj87" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 200px;\n  max-height: 40px;\n"], ["\n  max-width: 200px;\n  max-height: 40px;\n"])));
var templateObject_1;
